import { render, staticRenderFns } from "./PmProjectOverview.vue?vue&type=template&id=c507de32&scoped=true&"
import script from "./PmProjectOverview.vue?vue&type=script&lang=js&"
export * from "./PmProjectOverview.vue?vue&type=script&lang=js&"
import style0 from "./PmProjectOverview.vue?vue&type=style&index=0&id=c507de32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c507de32",
  null
  
)

export default component.exports